export const environment = {
  production: true,
  apiUrl: "YTB/api/",
  angularUrl: "https://www.yourtravelbooking.com/",
  serviceUrl:"http://backoffice.yourtravelbooking.com/",
  domain: 'https://www.yourtravelbooking.com/',  
  digicelCertificateUrl: "https://seal.digicert.com/seals/popup/?tag=CDUv_WQ4",
  knowledgeGraphInfo: { "@context": "https://schema.org", "@type": "Organization",    "name": "Your Travel Booking",

    "url": "https://www.yourtravelbooking.com",    "logo": "https://www.yourtravelbooking.com/assets/images/logo-white.png",

    "foundingDate": "2016",    "founders":    {      "@type": "Person",      "name": "Nageswara Rao Sure"    },

    "address": {      "@type": "PostalAddress",      "streetAddress": "6100 Greenland Rd #1001",      "addressLocality": "Jacksonville",      "addressRegion": "FL",

      "postalCode": "32258",      "addressCountry": "USA"    },    "contactPoint": {

      "@type": "ContactPoint",      "contactType": "customer support",      "telephone": "(904) 376-7145",      "email": "support@yourtravelbooking.com"

    },    "sameAs": [      "https://www.facebook.com/yourtravelbookings",      "https://twitter.com/Yourtravelbking",      "https://www.linkedin.com/company/29006263/admin/",      "https://yourtravelbooking.tumblr.com/",      "https://www.instagram.com/yourtravelbookingsite/",      "https://www.youtube.com/channel/UC5jA5z2EFEY60crd23jbBfg"    ]

  },
  isNdc:true,
  publicKey:`-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyj2Y9SiSO3yUbogAE+Vx
o+SKRZ5waWKM23iMNOhymVu3OSKCbmNY36sMWaFa54g8gu4lJJoaiEUTpNm0sqw5
vOHHXtQElh59qyZaxPxkKUPRSQ0j0/5xXkp9Hd9a77lshEkIWtNS+YG4kWyrZ01T
It/zKirl82+M5ADhQtGzx6TOy6773G+mn8KDZoWxF6DPX0PaFVf/zv/+ufTa6ZxU
M4WBxRWxFXli5jT5n7PWceuwIwh2rmmXTwEk/UPR5ULlY6s+Rbt0o+cnMJ89lKjZ
MginDqtuctTbDcsHPPrs+Nc2lywTXOsvDSt6uXb3DDyRXw1WcuqCVzphD1rpreh9
3QIDAQAB
-----END PUBLIC KEY-----`,
bbbUrl:'https://www.bbb.org/us/fl/jacksonville/profile/travel-agency/your-travel-booking-0403-235973612/#sealclick',
  serverApiUrl:'https://www.yourtravelbooking.com/YTB/api/'
};




